import React from "react";
import PageHeader from "../components/PageHeader";
import ContactForm from "../components/ContactForm";
import { volunteerReasons } from "../mock";

const BecomeVolunteer = () => {
  return (
    <div>
      <PageHeader title="You Should Become a BOT Community Volunteer If..." />

      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto space-y-16">
          {volunteerReasons.map((r, idx) => (
            <div
              key={r.title}
              className={`grid md:grid-cols-2 gap-10 items-center ${
                idx % 2 === 1 ? "md:[direction:rtl]" : ""
              }`}
            >
              <div className="[direction:ltr] overflow-hidden group">
                <img
                  src={r.image}
                  alt={r.title}
                  className="w-full h-[360px] object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="[direction:ltr]">
                <h3 className="font-display text-2xl md:text-3xl text-[#e8a13a] mb-4">
                  {r.title}
                </h3>
                <p className="text-[#d5c9a8] leading-relaxed">{r.body}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 px-6 bg-[#181818] border-t border-[#2a2a2a]">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-display text-3xl md:text-4xl text-[#e8a13a] mb-3 text-center">
            Interested in Becoming a BOT Community Volunteer?
          </h2>
          <p className="text-center text-[#c8bfae] mb-10">
            Let us pick your brain! Tell us a bit about yourself, and how you would like to be
            involved!
          </p>
          <ContactForm title="" storageKey="bot_volunteer_applications" />
          <p className="text-center mt-10 text-[#c8bfae] font-serif-italic">
            We look forward to seeing you in-person!
          </p>
        </div>
      </section>
    </div>
  );
};

export default BecomeVolunteer;
